import './CasDataGridPro.scss';

import { useState } from 'react';
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';

import CasIconButton from '../CasButton/CasIconButton';
import { CasStackRow } from '../CasStack/CasStackRow';

interface CasDataGridProProps extends DataGridProProps {
  /** Controlled full-screen state. When provided, the caller owns the toggle. */
  isFullScreen?: boolean;
  /** Hide the built-in full-screen button (e.g. when the caller renders its own). */
  hideFullScreenButton?: boolean;
}

export default function CasDataGridPro({
  isFullScreen: isFullScreenProp,
  hideFullScreenButton = false,
  ...props
}: CasDataGridProProps) {
  const [internalFullScreen, setInternalFullScreen] = useState(false);
  const isControlled = isFullScreenProp !== undefined;
  const isFullScreen = isControlled ? isFullScreenProp : internalFullScreen;

  const handleTableFullScreen = () => {
    setInternalFullScreen((prev) => !prev);
  };

  // In controlled mode the caller owns the full-screen overlay wrapper (so the
  // caller's toolbar stays visible); avoid double-applying the fixed overlay here.
  const applyFullScreenClass = !isControlled && isFullScreen;

  return (
    <div className={applyFullScreenClass ? 'table-fullscreen' : ''}>
      {!hideFullScreenButton && (
        <CasStackRow alignItems="center" justifyContent="flex-end">
          <CasIconButton
            icon={isFullScreen ? 'mdi:fullscreen-exit' : 'mdi:fullscreen'}
            onClick={handleTableFullScreen}
            tooltip="Toggle full screen"
          />
        </CasStackRow>
      )}

      <DataGridPro {...props} className="CasDataGridPro" />
    </div>
  );
}
